<template>
  <q-dialog
    :visible="isVisible"
    :title="title"
    width="800px"
    :innerScroll="false"
    @close="onCancel"
    :loading="loadingBth"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <el-form ref="editForm" :model="editForm" :rules="rules" label-width="130px" size="mini" v-loading="loading">
      <el-row>
        <el-col :span="12">
          <el-form-item label="产品编码:">
            {{ rowData.productCode }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="产品名称:">
            <el-tooltip class="item" effect="dark" :content="rowData.productName" placement="top" v-if="rowData.productName && rowData.productName.length >= 20">
              <div class="tips">{{rowData.productName}}</div>
            </el-tooltip>
            <span v-else>{{ rowData.productName }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="A类价:">
            {{editForm.retailPrice }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="组合S级到手价:" prop="groupPriceS">
            <el-input v-model="editForm.groupPriceS" @input="onInputType('groupPriceS')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="单品S级到手价:" prop="singlePriceS">
            <el-input v-model="editForm.singlePriceS" @input="onInputType('singlePriceS')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="组合A级到手价:" prop="groupPriceA">
            <el-input v-model="editForm.groupPriceA" @input="onInputType('groupPriceA')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="单品A级到手价:" prop="singlePriceA">
            <el-input v-model="editForm.singlePriceA" @input="onInputType('singlePriceA')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="组合日常到手价:" prop="groupPriceDaily">
            <el-input v-model="editForm.groupPriceDaily" @input="onInputType('groupPriceDaily')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="单品日常到手价:" prop="singlePriceDaily">
            <el-input v-model="editForm.singlePriceDaily" @input="onInputType('singlePriceDaily')"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </q-dialog>
</template>

<script>
export default {
  name: 'CRUDEdit',
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    rowData: Object,
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    title() {
      return '编辑';
    },
  },
  data() {
    return {
      loading: false,
      loadingBth: false,
      editForm: {},
      rules: {
        // groupPriceS: [
        //   { required: true, message: '不能为空', trigger: 'blur' },
        // ],
        // singlePriceS: [
        //   { required: true, message: '不能为空', trigger: 'blur' },
        // ],
        // groupPriceA: [
        //   { required: true, message: '不能为空', trigger: 'blur' },
        // ],
        // singlePriceA: [
        //   { required: true, message: '不能为空', trigger: 'blur' },
        // ],
        // groupPriceDaily: [
        //   { required: true, message: '不能为空', trigger: 'blur' },
        // ],
        // singlePriceDaily: [
        //   { required: true, message: '不能为空', trigger: 'blur' },
        // ],
      },
    };
  },
  created() {
    this.editForm = this.rowData
    // if(this.rowData.combinationFlag == '否') {
    //   this.rules.groupPriceS[0].required = false
    //   this.rules.groupPriceA[0].required = false
    //   this.rules.groupPriceDaily[0].required = false
    // }
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      this.$refs.editForm.validate((valid) => {
        if (!valid) return;
        this.loadingBth = true;
        let data = {}
        Object.keys(this.editForm).map(v=>{
          data[v] = this.editForm[v] || null
        })
        this.$q.product
          .wholePriceUpdate({ data: data })
          .then((res) => {
            if (res.success) {
              let text = '编辑成功';
              this.$message.success(text);
              this.isVisible = false;
              this.$emit('success');
            }
          })
          .finally((_) => {
            this.loadingBth = false;
          });
      });
    },
    onInputType(prop) {
      this.editForm[prop] = this.editForm[prop].replace(/^(0+)|[^\d]+/g, '')
    },
    async init() {},
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-input--small .el-input__inner, >>> .el-date-editor.el-input, >>> .el-date-editor.el-input__inner
  width 200px !important
>>> .el-input
  width 200px !important

.tips {
  width: 100%
  overflow:hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
